import TranscriptsListItem from './TranscriptsListItem.vue'
import TranscriptsContainer from './TranscriptsContainer.vue'

const transcriptsComponents = [TranscriptsListItem, TranscriptsContainer]

export default transcriptsComponents
